/**
 * A frase que explica por que uma caixa de estoque está desabilitada — F102.
 *
 * ## Por que uma constante, e não três cópias
 *
 * A F070 recusou o interruptor mestre com um argumento exato: uma chave da
 * empresa mandando por cima do produto criaria uma segunda fonte de verdade —
 * *"a tela do produto mostraria 'controla estoque' marcado enquanto o PDV
 * ignora"*. A objeção continua correta, e o que a desarma é a tela DIZER o
 * motivo em todo lugar onde a informação aparece.
 *
 * Três frases escritas à mão em três telas divergem em duas semanas, e quando
 * divergirem a objeção volta a valer sem ninguém perceber. Uma constante é o
 * que torna a mitigação verificável: se alguma tela nova mostrar
 * `tracksStock` sem chamar isto, falta ali.
 *
 * ## Por que ela nomeia a empresa
 *
 * Produto é do TENANT; a política é da EMPRESA. Num tenant com duas empresas a
 * mesma caixa está desligada numa e ligada na outra, e "esta loja não controla
 * estoque" seria falso metade das vezes para quem está lendo.
 */
export const stockDisabledBecause = (companyName: string): string =>
  `${companyName} não controla estoque, então este produto não tem saldo. Para mudar, vá em Configurações → Empresa → Estoque nas vendas.`

/**
 * O aviso do topo da tela de Estoque, quando ela ainda pode ser aberta pela
 * URL — a linha do menu já sumiu.
 */
export const stockScreenNotice = (companyName: string): string =>
  `${companyName} não controla estoque. Os saldos abaixo são o histórico do que existia antes, e não mudam mais com as vendas.`
